import { SubscriptionFreemiumAPICall } from 'reactApp/api/billing/subscription/SubscriptionFreemiumAPICall';
import { freemiumTariffID, isSoftFreemium } from 'reactApp/appHelpers/featuresHelpers/features/freemium';
import { BillingActions } from 'reactApp/modules/billing/billing.module';
import type { FreemiumApiParams } from 'reactApp/modules/billing/billing.types';
import { loggerSaga } from 'reactApp/modules/logger/logger.saga';
import { sendXray } from 'reactApp/utils/ga';
import opener from 'reactApp/utils/opener';
import { put } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';

export const subscriptionFreemiumAPICall = (params: FreemiumApiParams) => new SubscriptionFreemiumAPICall().makeRequest(params);

export function* handleSubscribeOnFreemium() {
    const params: FreemiumApiParams = {
        product_id: freemiumTariffID,
        action: 'set',
    };

    try {
        const { data } = yield* call(subscriptionFreemiumAPICall, params);

        if (!!data?.error && !data?.result) {
            sendXray(['blng', 'freemium', 'error', 'response']);
            return;
        }

        yield put(BillingActions.freemiumIsLoaded());
        if (isSoftFreemium) {
            opener('/family/folders?freemiumOnboard=true', true);
        }
    } catch (error) {
        sendXray(['blng', 'freemium', 'error', 'code']);
        yield loggerSaga({ error });
    }
}
